export default __webpack_public_path__ + "static/media/gallery42.66277c41.jpg";